module.exports = __webpack_public_path__ + "img/shareWX.c8c77ce1.png";